<script>
  import programListItem from '@/components/list-item-program.vue'

  import * as api from '@/utils/api'
  import * as dtUtils from '@/utils/datetime'

  const MARKET_CATEGORIES = {
    2: 'children',
    3: 'teen',
    4: 'adult',
    5: 'everyone'
  }

  const MARKET_CATEGORIES_QUERY_STRINGS = {
    adult: 'age_groups[4]=4',
    children: 'age_groups[2]=2&age_groups[252]=252&age_groups[249]=249&age_groups[250]=250&age_groups[251]=251',
    everyone: 'age_groups[5]=5',
    teen: 'age_groups[3]=3'
  }

  export default {
    name: 'cardPrograms',
    components: { programListItem },
    props: {
      backgroundImage: {
        type: String,
        default: () => '../../public/test/event1.jpg'
      },
      cardColor: {
        type: String,
        default: () => 'secondary'
      },
      queryCategory: {
        type: String,
        default: () => null
      },
      showFilters: {
        type: Boolean,
        default: () => true
      },
      textColor: {
        type: String,
        default: () => 'primary'
      }
    },
    data: () => ({
      categoryColors: {
        adult: '#000066',
        children: '#4caf50',
        teen: '#00bcd4'
      },
      categoryFilter: [],
      // categoryFilter: ['adult', 'children', 'teen'],
      isLoading: true,
      listItemExpanded: null,
      programModalProgram: {},
      programsUpcoming: [],
      searchInput: null,
      showAlert: false,
      showProgramModal: false
    }),
    computed: {
      programsDisplayed() {
        if (!this.categoryFilter.length && !this.searchInput) return this.programsUpcoming
        let filteredPrograms = [...this.programsUpcoming]

        if (this.categoryFilter?.length) {
          filteredPrograms = [...filteredPrograms].filter(p => {
            let isMatch = false
            this.categoryFilter.forEach(cat => {
              if (cat === 'teen') cat = 'young adults'
              if (p.category.toLowerCase().includes(cat)) {
                isMatch = true
              }
            })
            return isMatch
          })
        }

        if (this.searchInput) {
          filteredPrograms = [...filteredPrograms].filter(p => {
            const { title, description, program_description, program_type } = p
            const searchables = { title, description, program_description, program_type }
            return JSON.stringify(Object.values(searchables)).toLowerCase().includes(this.searchInput.toLowerCase().trim())
          })
        }
        return filteredPrograms
      }
    },
    methods: {
      calendarSearchUrl() {
        const BASE_URL = 'https://eastislip.librarycalendar.com/events/list'
        let url = BASE_URL
        if (this.searchInput) {
          url += `?keywords=${this.searchInput}`
        }

        if (this.categoryFilter?.length) {
          url += url.includes('?') ? '&' : '?'
          for (const cat of this.categoryFilter) {
            console.log(cat)
            const id = Object.keys(MARKET_CATEGORIES).find(key => MARKET_CATEGORIES[key] === cat)
            if (id) {
              url += `age_groups[${id}]=${id}&`
            }
          }
        } else if (this.queryCategory) {
          const catStr = MARKET_CATEGORIES_QUERY_STRINGS[this?.queryCategory?.toLowerCase()] || ''
          if (catStr) {
            url += url.includes('?') ? '&' : '?'
            url += `&${catStr}`
          }
        }
        return url
      },
      catalogLink(record) {
        const baseUrl = 'https://search.livebrary.com/record=[RECORD_ID]&searchscope=20&SORT2=R'
        const href = baseUrl.replaceAll('[RECORD_ID]', record)
        return href
      },
      category(item) {
        if (!item?.age_group || typeof item.age_group !== 'object') return 'everyone'
        return Object.values(item?.age_group)?.[0]?.toLowerCase() || 'everyone'
      },
      categoryOLD(item) {
        let category = ''
        if (item.subject1 && item.subject1 !== null && item.subject1 !== '') {
          category = item.subject1.trim()
          if (item.subject2 && item.subject2 !== null && item.subject2 !== '') {
            category += ', ' + item.subject2.trim()
          }
          return category
        }
        if (item.subject2 && item.subject2 !== null && item.subject2 !== '') {
          category = item.subject2
        }
        return category
      },
      categoryColor(category = '') {
        const defaultColor = 'primary'
        const cat = category?.toLocaleLowerCase() || ''
        if (!cat) return defaultColor
        if (cat.includes('children')) return this.categoryColors.children
        if (cat.includes('teen')) return this.categoryColors.teen
        if (cat.includes('young adults')) return this.categoryColors.teen
        if (cat.includes('adult')) return this.categoryColors.adult
        return defaultColor
      },
      clearFilters() {
        this.categoryFilter = []
        this.searchInput = null
      },
      displayProgramModal(e) {
        console.log('displayProgramModal')
        console.log(e)
        this.programModalProgram = e
        this.showProgramModal = true
      },
      getLibraryMarket() {
        const BASE_URL = 'https://eastislip.librarycalendar.com/events/feed/json'

        const dayRange = 15
        const start = new Date()
        const end = new Date()
        end.setDate(end.getDate() + dayRange)
        const sqlStart = dtUtils.timestampSql(start, false)
        const sqlEnd = dtUtils.timestampSql(end, false)
        let endpoint = BASE_URL
        endpoint += `?start=${sqlStart}&end=${sqlEnd}`
        if (this.queryCategory) {
          const catStr = MARKET_CATEGORIES_QUERY_STRINGS[this?.queryCategory?.toLowerCase()] || ''
          if (catStr) {
            endpoint += `&${catStr}`
          }
        }
        api.get(endpoint, { withCredentials: false }, false).then(response => {
          // this.programsUpcoming = response
          //TODO: HANDLE ERROR
          // console.log(response)
          const programs = response?.length ? response.filter(p => p.public && p.published) : []
          this.setPrograms(programs)
          this.isLoading = false
        })
      },
      onProgramItemInput(program) {
        // console.log(program)
        this.listItemExpanded = this.listItemExpanded === program.id ? null : program.id
        // const listEl = document.getElementById('programlistCardText')
        // const listItemEl = document.getElementById(`program${program.id}`)
        // const listItemOffset = listItemEl.offsetTop
        // console.dir(listEl)
        // listEl.scrollTo(listItemOffset)

        // listEl.scroll(listItemOffset)
        // this.$nextTick(() => {
        //   // listItemEl.scrollIntoView()
        //   console.log(listEl)
        //   console.log(listItemEl.offsetTop)
        // })
        //TODO: scroll expanded program to top of list
        // const listTop = this.$refs.programlist.$el.offsetTop
        // console.log(this.listItemExpanded)
        // if (this.listItemExpanded) {
        //   const el = document.querySelector(`#program${program.id}`)
        //   console.dir(el)
        //   console.dir(el?.offsetTop)
        //   if (el?.offsetTop) {
        //     const listItemTop = el.offsetTop
        //     this.$nextTick(() => (this.$refs.programlist.$el.scrollTop = listItemTop))
        //     // this.$nextTick(() => this.$refs.programlist.$el.scroll({ top: el.offsetTop, behavior: 'smooth' }))

        //     //   this.$nextTick(() => el.scrollIntoView({ behavior: 'smooth', block: 'end' }))
        //   }
        // }
        // this.$vuetify.goTo(`#program${program.id}`)
        // console.log(this.$refs.programlist)
        // this.$refs.programlist.$el.scrollTo(`#program${program.id}`)
      },
      setProgramsOld(programs) {
        //from in house db
        const programData = programs.map(p => {
          const program = { ...p }
          const startDt = dtUtils.toDateClass(`${p.date} ${p.time_start}`)
          const endDt = dtUtils.toDateClass(`${p.date} ${p.time_end}`)
          // const endTimestamp = `${p.date} ${p.time_end}`
          program.catalogLink = this.catalogLink(p.record_id)
          program.category = this.category(p)
          program.categoryColor = this.categoryColor(program.category)
          program.dayOfWeek = dtUtils.dayOfWeek(startDt)
          program.dateHuman = dtUtils.humanDate(startDt, false, false)
          program.dateTimeHuman = dtUtils.humanDateTime(startDt, false, true)
          program.dateHumanKeyword = dtUtils.humanDate(startDt, true, false)
          program.timeStartEpoch = startDt.getTime()
          program.timeStartHuman = dtUtils.humanTime(startDt)
          program.timeEndHuman = dtUtils.humanTime(endDt)

          return program
        })
        this.programsUpcoming = programData.sort((a, b) => a.timeStartEpoch - b.timeStartEpoch)
      },
      setPrograms(programs) {
        //TODO:
        //PICK UP HERE,
        //MAP over program list, set all values here.
        const programData = programs.map(p => {
          const program = { ...p }
          const startDt = dtUtils.toDateClass(p.start_date)
          const endDt = dtUtils.toDateClass(p.end_date)
          // const endTimestamp = `${p.date} ${p.time_end}`
          program.category = this.category(p)
          program.categoryColor = this.categoryColor(program.category)
          program.dayOfWeek = dtUtils.dayOfWeek(startDt)
          program.dateHuman = dtUtils.humanDate(startDt, false, false)
          program.dateTimeHuman = dtUtils.humanDateTime(startDt, false, true)
          program.dateHumanKeyword = dtUtils.humanDate(startDt, true, false)
          program.location = p?.room ? Object.values(p?.room)?.[0] : ''
          program.program_description = p?.program_description ? Object.values(p?.program_description)?.[0] : ''

          program.timeStartEpoch = startDt.getTime()
          program.timeStartHuman = dtUtils.humanTime(startDt)
          program.timeEndHuman = dtUtils.humanTime(endDt)
          program.types = p?.program_type ? Object.entries(p.program_type).map(([id, text]) => ({ id, text })) : []

          if (program?.registration_start && program?.registration_end) {
            program.registrationWindow = `${dtUtils.humanDateTime(program.registration_start, false, false)} - ${dtUtils.humanDateTime(program.registration_end, false, false)}`
          }

          return program
        })
        this.programsUpcoming = programData.sort((a, b) => a.timeStartEpoch - b.timeStartEpoch)
      }
    },

    created() {},
    async mounted() {
      await this.getLibraryMarket()
      return

      const dayRange = 5
      const start = new Date()
      const end = new Date()
      end.setDate(end.getDate() + dayRange)
      const sqlStart = dtUtils.timestampSql(start, false)
      const sqlEnd = dtUtils.timestampSql(end, false)
      let endpoint = `programs/${sqlStart}/${0}/${sqlEnd}`
      if (this.queryCategory) {
        endpoint += `?cat=${this.queryCategory}`
      }
      api.get(endpoint).then(response => {
        // this.programsUpcoming = response
        //TODO: HANDLE ERROR
        this.setPrograms(response)
        this.isLoading = false
      })
    }
  }
</script>
<template>
  <!-- max-height="550" -->
  <v-card :color="cardColor" tile class="card rounded-lg" :style="{ overflow: 'hidden' }">
    <!-- <v-img cover :src="backgroundImage" height="100%" width="100%" :class="`${textColor}--text`"> -->
    <v-card-title>
      <a
        href="https://eastislip.librarycalendar.com/events/month"
        target="_blank"
        class="d-flex title-text align-center text-wrap"
        :class="`${textColor}--text`"
        style="text-decoration: none"
      >
        <v-icon :color="textColor" left>mdi-calendar</v-icon>

        <h2 class="text-h5 font-weight-black">UPCOMING PROGRAMS</h2></a
      >
    </v-card-title>
    <!-- <v-alert border="left" dismissible outlined type="warning" class="mx-4">
      <div class="font-weight-bold">Please Note!</div>
      <div>The library is transitioning to a new, improved program system.</div>
      <div>Please use the old calendar for the following:</div>
      <div class="mt-2">Adult & Teen programs for October.</div>
      <div>Children's programs for October and November.</div>
      <v-btn color="warning" href="https://search.livebrary.com//iii/calendar/month/C&R=20" target="_blank" class="mt-4"><v-icon left>mdi-calendar</v-icon> old calendar</v-btn>
    </v-alert> -->
    <v-alert :value="showAlert" border="left" dismissible type="warning" class="primary--text mx-4">
      <div class="font-weight-bold">Please Note!</div>
      <div>The library is transitioning to a new, improved program system.</div>
      <div>Please use the old calendar for the following:</div>
      <div class="mt-2">Adult & Teen programs for October.</div>
      <div>Children's programs for October and November.</div>
      <v-btn color="primary" href="https://search.livebrary.com//iii/calendar/month/C&R=20" target="_blank" class="mt-4"><v-icon left>mdi-calendar</v-icon> old calendar</v-btn>
    </v-alert>
    <v-card-text v-if="!isLoading && showFilters" class="d-flex align-center justify-center rounded-lg pa-4">
      <!-- max-width="1100px" width="100%" -->
      <v-sheet color="transparent" width="100%" class="card-text d-flex align-center justify-start flex-wrap" style="overflow-y: hidden">
        <!-- FILTERS -->
        <v-sheet color="secondary" width="100%" class="d-flex flex-column align-start justify-start flex-wrap rounded-lg mb-4 pa-2">
          <v-sheet color="transparent" class="d-flex align-center mb-2">
            <v-icon color="primary" title="Filter results by department" class="mr-1">mdi-filter</v-icon>
            <h3 class="text-h6 font-weight-bold primary--text">FILTERS</h3>
            <v-btn v-if="categoryFilter?.length || searchInput" color="error" dense text x-small @click="clearFilters" class="ml-2">
              <v-icon color="error" x-small>mdi-filter-remove</v-icon> Clear All</v-btn
            >
          </v-sheet>
          <v-row no-gutters align="end" justify="space-between" style="width: 100%">
            <v-col cols="12" sm="6" xl="12">
              <v-sheet color="transparent" class="d-flex flex-shrink-1">
                <v-chip-group v-model="categoryFilter" multiple class="pa-0">
                  <v-chip v-for="[cat, color] in Object.entries(categoryColors)" :key="cat" :value="cat" :color="color" filter class="white--text font-weight-bold mr-4">
                    <!-- TODO: FIX THIS WORKAROUND WHEN PULLING FROM NEW PROGRAM SOURCE -->
                    {{ cat === 'children' ? 'KIDS' : cat.toLocaleUpperCase() }}
                  </v-chip>
                </v-chip-group>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="6" xl="4">
              <v-sheet color="transparent" width="auto" class="d-flex flex-grow-1 my-2 ml-auto">
                <v-text-field
                  v-model="searchInput"
                  clearable
                  color="primary"
                  dense
                  hide-details=""
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  rounded
                  solo
                  type="text"
                  class="primary--text"
                >
                  <template v-slot:append>
                    <v-fade-transition leave-absolute>
                      <v-btn v-if="searchInput" color="primary" :href="calendarSearchUrl()" target="_blank" rounded small>
                        <v-icon left small> mdi-calendar-search-outline</v-icon>
                        all
                      </v-btn>
                    </v-fade-transition>
                  </template>
                </v-text-field>
              </v-sheet>
            </v-col>
          </v-row>
        </v-sheet>
      </v-sheet>
    </v-card-text>
    <v-card-text id="programlistCardText" class="program-list transparent py-0 rounded-lg">
      <v-sheet style="height: 100%" class="rounded-lg">
        <v-card v-if="isLoading" flat>
          <v-card-text class="d-flex flex-column align-center justify-center">
            <v-progress-circular indeterminate color="primary" v-if="isLoading" class="mt-4"></v-progress-circular>
            <p class="text-h6 primary--text">Getting upcoming programs...</p>
          </v-card-text>
        </v-card>
        <v-sheet v-else-if="!programsDisplayed.length" class="primary--text font-weight-bold rounded-lg pa-4">
          <p>{{ `No programs were found ${categoryFilter.length || searchInput ? 'matching the applied filters ' : ''}within the next 14 days.` }}</p>
          <v-btn color="primary" :href="calendarSearchUrl()" target="_blank" class="mt-auto"><v-icon left>mdi-calendar-search</v-icon>SEARCH ALL PROGRAMS </v-btn>
        </v-sheet>
        <v-list v-else dense color="secondary" two-line width="100%" class="rounded-lg pb-8" :class="showFilters ? 'mb-8' : ''">
          <template v-for="program in programsDisplayed">
            <programListItem
              :id="'program' + program.id"
              :key="program.id"
              :item="program"
              @input="onProgramItemInput(program)"
              :expanded="listItemExpanded === program.id"
              class="mb-2"
            ></programListItem>
            <v-divider :key="`d${program.id}`" color="primary" inset class="list-item-divider"></v-divider>
          </template>
          <!-- extra list item so list has room to expand at bottom-->
        </v-list>
      </v-sheet>
    </v-card-text>
    <v-card-actions class="px-8 py-8">
      <v-btn block large tile href="https://eastislip.librarycalendar.com/events/month" target="_blank" color="secondary" class="primary--text font-weight-bold rounded-lg">
        <v-icon left>mdi-calendar-text</v-icon>VIEW ALL PROGRAMS
      </v-btn>
    </v-card-actions>
    <!-- </v-img> -->
  </v-card>
</template>
<style scoped>
  >>> .v-input__slot {
    padding-inline: 10px !important;
  }

  .card {
    /* background-color: #dcf4e8; */
    /* background-image: url('../../public/test/event1.jpg'); */
    /* background-size: cover; */
    /* background-position: center right; */
    /* background-repeat: repeat; */
    /* background-size: 100%; */
  }

  .title-text {
    /* background: linear-gradient(180deg, #fff 0%, rgba(0, 0, 0, 0) 100%); */
    /* color: #2a9effd4; */
    /* color: #6bbcfe; */
    white-space: nowrap;
    /* height: 100px; */
  }

  .program-list {
    height: 450px;
    min-height: 450px;
    overflow-y: scroll;
    /* background-color: #70a3cfde; */
    /* background-color: #ffff00a1; */
    border-radius: 5px;
    /* overflow: hidden; */
  }

  .list-item-divider {
    border-color: #00006657;
  }
</style>
